export default defineNuxtRouteMiddleware((to) => {
  const localeRoute = useLocaleRoute()

  if (to.path === localeRoute('/pro')?.path) {
    return navigateTo(localeRoute('/media-pro')?.path, { redirectCode: 301 })
  }
})
